// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerifyPhoneNumberForm-errorMessage-i3NNr {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.VerifyPhoneNumberForm-space1-n6zsC {
	margin-bottom: 6px !important;
}
.VerifyPhoneNumberForm-space2-qoNlH {
	margin-bottom: 12px !important;
}
.VerifyPhoneNumberForm-space3-Oxqet {
	margin-bottom: 18px !important;
}
.VerifyPhoneNumberForm-space4-LvT18 {
	margin-bottom: 24px !important;
}
.VerifyPhoneNumberForm-space5-AYyhu {
	margin-bottom: 30px !important;
}
.VerifyPhoneNumberForm-space6-RMXXi {
	margin-bottom: 36px !important;
}
.VerifyPhoneNumberForm-space7-z4yO0 {
	margin-bottom: 42px !important;
}
.VerifyPhoneNumberForm-spaceTop8-WfcQz {
	margin-bottom: 48px !important;
}
.VerifyPhoneNumberForm-spaceTop1-H6wGd {
	margin-top: 6px !important;
}
.VerifyPhoneNumberForm-spaceTop2-GOLby {
	margin-top: 12px !important;
}
.VerifyPhoneNumberForm-spaceTop3-PYdNf {
	margin-top: 18px !important;
}
.VerifyPhoneNumberForm-spaceTop4-WaWgs {
	margin-top: 24px !important;
}
.VerifyPhoneNumberForm-spaceTop5-RwSWW {
	margin-top: 30px !important;
}
.VerifyPhoneNumberForm-spaceTop6-Up9Yy {
	margin-top: 36px !important;
}
.VerifyPhoneNumberForm-spaceTop7-b7SM7 {
	margin-top: 42px !important;
}
.VerifyPhoneNumberForm-spaceTop8-WfcQz {
	margin-top: 48px !important;
}
.VerifyPhoneNumberForm-noMargin-xZwr6 {
	margin: 0px !important;
}
.VerifyPhoneNumberForm-padding1-zyFuz {
	padding-bottom: 6px !important;
}
.VerifyPhoneNumberForm-padding2-ZJCvf {
	padding-bottom: 12px !important;
}
.VerifyPhoneNumberForm-padding3-nras0 {
	padding-bottom: 18px !important;
}
.VerifyPhoneNumberForm-padding4-M2TzF {
	padding-bottom: 24px !important;
}
.VerifyPhoneNumberForm-padding5-v5JDc {
	padding-bottom: 30px !important;
}
.VerifyPhoneNumberForm-padding6-KgCmP {
	padding-bottom: 36px !important;
}
.VerifyPhoneNumberForm-padding7-DnCfO {
	padding-bottom: 42px !important;
}
.VerifyPhoneNumberForm-paddingTop1-x1phY {
	padding-top: 6px !important;
}
.VerifyPhoneNumberForm-paddingTop2-zhBoR {
	padding-top: 12px !important;
}
.VerifyPhoneNumberForm-paddingTop3-QcgZF {
	padding-top: 18px !important;
}
.VerifyPhoneNumberForm-paddingTop4-qx7rd {
	padding-top: 24px !important;
}
.VerifyPhoneNumberForm-paddingTop5-I7XEU {
	padding-top: 30px !important;
}
.VerifyPhoneNumberForm-paddingTop6-Y6weX {
	padding-top: 36px !important;
}
.VerifyPhoneNumberForm-paddingTop7-FJozE {
	padding-top: 42px !important;
}
.VerifyPhoneNumberForm-noPadding-3Pxca {
	padding: 0px !important;
}
.VerifyPhoneNumberForm-textBold-abvtn {
	font-weight: 500 !important;
}
.VerifyPhoneNumberForm-textBolder-lkiGu {
	font-weight: 700 !important;
}
.VerifyPhoneNumberForm-textNormal-J5KJh {
	font-weight: normal !important;
}
.VerifyPhoneNumberForm-spaceBottom20-GRK42 {
	margin-bottom: 20px;
}
.VerifyPhoneNumberForm-spaceBottom10-duwLm {
	margin-bottom: 10px;
}
.VerifyPhoneNumberForm-marginNone-UWAoW {
	margin: 0;
}
.VerifyPhoneNumberForm-spaceBottom15-yheao {
	margin-bottom: 15px;
}
.VerifyPhoneNumberForm-marginTopNone-vyBz4 {
	margin-top: 0;
}
.VerifyPhoneNumberForm-spaceTop11-lRw9o {
	margin-top: 11px;
}
.VerifyPhoneNumberForm-spaceTop21-Tie_T {
	margin-top: 21px;
}
.VerifyPhoneNumberForm-spaceTop20-Qyf00 {
	margin-top: 20px;
}
.VerifyPhoneNumberForm-spaceTop10-tMwR9 {
	margin-top: 10px;
}
/*New Design Text Colors */
.VerifyPhoneNumberForm-textDarkBlue-wLuqJ {
	color: rgb(20, 39, 94) !important;
}
.VerifyPhoneNumberForm-textLightBlue-TYMCL {
	color: rgb(57, 87, 106) !important;
}
.VerifyPhoneNumberForm-textLightSandleGreen-rrGFy {
	color: rgb(76, 86, 41) !important;
}
.VerifyPhoneNumberForm-textLightBrown-APZvL {
	color: rgb(115, 79, 33) !important;
}
.VerifyPhoneNumberForm-textMediumMaroon-aX9sM {
	color: rgb(87, 37, 51) !important;
}
.VerifyPhoneNumberForm-textBrown-nlAPC {
	color: rgb(160, 47, 24) !important;
}
.VerifyPhoneNumberForm-textMaroon-mw20p {
	color: rgb(155, 49, 67) !important;
}
.VerifyPhoneNumberForm-textDarkBrown-Gvzsw {
	color: rgb(83, 18, 16) !important;
}
.VerifyPhoneNumberForm-textMediumBrown-JfxnB {
	color: rgb(142, 28, 10) !important;
}
.VerifyPhoneNumberForm-textSkyBlue-xDPJt {
	color: rgb(37, 117, 141) !important;
}
.VerifyPhoneNumberForm-textGray-hgabo {
	color: rgb(77, 65, 51) !important;
}
/** RentAll - Begin **/
.VerifyPhoneNumberForm-formGroup-BVzSs {
	margin-bottom: 15px !important;
}
.VerifyPhoneNumberForm-labelText-DtQfC {
	font-size: 15px;
	color: var(--secondary-foreground);
	margin: 6px 0px;
	line-height: 1.43;
	font-weight: normal;
}
.VerifyPhoneNumberForm-modalCaptionLink-FuW1H {
	color: var(--primary-link-foreground);
}
.VerifyPhoneNumberForm-modalCaptionLinkLarge-K6HKa {
	font-size: 16px;
	line-height: 32px;
}
.VerifyPhoneNumberForm-modalCaptionLink-FuW1H:hover,
.VerifyPhoneNumberForm-modalCaptionLink-FuW1H:focus {
	color: var(--primary-link-foreground);
	text-decoration: underline;
}
.VerifyPhoneNumberForm-formContainer-yaSMA {
	border: 1px solid var(--primary-border);
	padding: 15px;
	border-radius: 2px;
}
.VerifyPhoneNumberForm-btnContainer-mTUHq {
	display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/PhoneVerificationModal/VerifyPhoneNumberForm/VerifyPhoneNumberForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,sBAAsB;AACtB;CACC,8BAA8B;AAC/B;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,qCAAqC;AACtC;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;AAEA;;CAEC,qCAAqC;CACrC,0BAA0B;AAC3B;AAEA;CACC,uCAAuC;CACvC,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,qBAAqB;AACtB","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../utils.css';\n@import '../../helpers.css';\n\n/** RentAll - Begin **/\n.formGroup {\n\tmargin-bottom: 15px !important;\n}\n\n.labelText {\n\tfont-size: 15px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 6px 0px;\n\tline-height: 1.43;\n\tfont-weight: normal;\n}\n\n.modalCaptionLink {\n\tcolor: var(--primary-link-foreground);\n}\n\n.modalCaptionLinkLarge {\n\tfont-size: 16px;\n\tline-height: 32px;\n}\n\n.modalCaptionLink:hover,\n.modalCaptionLink:focus {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: underline;\n}\n\n.formContainer {\n\tborder: 1px solid var(--primary-border);\n\tpadding: 15px;\n\tborder-radius: 2px;\n}\n\n.btnContainer {\n\tdisplay: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `VerifyPhoneNumberForm-errorMessage-i3NNr`,
	"space1": `VerifyPhoneNumberForm-space1-n6zsC`,
	"space2": `VerifyPhoneNumberForm-space2-qoNlH`,
	"space3": `VerifyPhoneNumberForm-space3-Oxqet`,
	"space4": `VerifyPhoneNumberForm-space4-LvT18`,
	"space5": `VerifyPhoneNumberForm-space5-AYyhu`,
	"space6": `VerifyPhoneNumberForm-space6-RMXXi`,
	"space7": `VerifyPhoneNumberForm-space7-z4yO0`,
	"spaceTop8": `VerifyPhoneNumberForm-spaceTop8-WfcQz`,
	"spaceTop1": `VerifyPhoneNumberForm-spaceTop1-H6wGd`,
	"spaceTop2": `VerifyPhoneNumberForm-spaceTop2-GOLby`,
	"spaceTop3": `VerifyPhoneNumberForm-spaceTop3-PYdNf`,
	"spaceTop4": `VerifyPhoneNumberForm-spaceTop4-WaWgs`,
	"spaceTop5": `VerifyPhoneNumberForm-spaceTop5-RwSWW`,
	"spaceTop6": `VerifyPhoneNumberForm-spaceTop6-Up9Yy`,
	"spaceTop7": `VerifyPhoneNumberForm-spaceTop7-b7SM7`,
	"noMargin": `VerifyPhoneNumberForm-noMargin-xZwr6`,
	"padding1": `VerifyPhoneNumberForm-padding1-zyFuz`,
	"padding2": `VerifyPhoneNumberForm-padding2-ZJCvf`,
	"padding3": `VerifyPhoneNumberForm-padding3-nras0`,
	"padding4": `VerifyPhoneNumberForm-padding4-M2TzF`,
	"padding5": `VerifyPhoneNumberForm-padding5-v5JDc`,
	"padding6": `VerifyPhoneNumberForm-padding6-KgCmP`,
	"padding7": `VerifyPhoneNumberForm-padding7-DnCfO`,
	"paddingTop1": `VerifyPhoneNumberForm-paddingTop1-x1phY`,
	"paddingTop2": `VerifyPhoneNumberForm-paddingTop2-zhBoR`,
	"paddingTop3": `VerifyPhoneNumberForm-paddingTop3-QcgZF`,
	"paddingTop4": `VerifyPhoneNumberForm-paddingTop4-qx7rd`,
	"paddingTop5": `VerifyPhoneNumberForm-paddingTop5-I7XEU`,
	"paddingTop6": `VerifyPhoneNumberForm-paddingTop6-Y6weX`,
	"paddingTop7": `VerifyPhoneNumberForm-paddingTop7-FJozE`,
	"noPadding": `VerifyPhoneNumberForm-noPadding-3Pxca`,
	"textBold": `VerifyPhoneNumberForm-textBold-abvtn`,
	"textBolder": `VerifyPhoneNumberForm-textBolder-lkiGu`,
	"textNormal": `VerifyPhoneNumberForm-textNormal-J5KJh`,
	"spaceBottom20": `VerifyPhoneNumberForm-spaceBottom20-GRK42`,
	"spaceBottom10": `VerifyPhoneNumberForm-spaceBottom10-duwLm`,
	"marginNone": `VerifyPhoneNumberForm-marginNone-UWAoW`,
	"spaceBottom15": `VerifyPhoneNumberForm-spaceBottom15-yheao`,
	"marginTopNone": `VerifyPhoneNumberForm-marginTopNone-vyBz4`,
	"spaceTop11": `VerifyPhoneNumberForm-spaceTop11-lRw9o`,
	"spaceTop21": `VerifyPhoneNumberForm-spaceTop21-Tie_T`,
	"spaceTop20": `VerifyPhoneNumberForm-spaceTop20-Qyf00`,
	"spaceTop10": `VerifyPhoneNumberForm-spaceTop10-tMwR9`,
	"textDarkBlue": `VerifyPhoneNumberForm-textDarkBlue-wLuqJ`,
	"textLightBlue": `VerifyPhoneNumberForm-textLightBlue-TYMCL`,
	"textLightSandleGreen": `VerifyPhoneNumberForm-textLightSandleGreen-rrGFy`,
	"textLightBrown": `VerifyPhoneNumberForm-textLightBrown-APZvL`,
	"textMediumMaroon": `VerifyPhoneNumberForm-textMediumMaroon-aX9sM`,
	"textBrown": `VerifyPhoneNumberForm-textBrown-nlAPC`,
	"textMaroon": `VerifyPhoneNumberForm-textMaroon-mw20p`,
	"textDarkBrown": `VerifyPhoneNumberForm-textDarkBrown-Gvzsw`,
	"textMediumBrown": `VerifyPhoneNumberForm-textMediumBrown-JfxnB`,
	"textSkyBlue": `VerifyPhoneNumberForm-textSkyBlue-xDPJt`,
	"textGray": `VerifyPhoneNumberForm-textGray-hgabo`,
	"formGroup": `VerifyPhoneNumberForm-formGroup-BVzSs`,
	"labelText": `VerifyPhoneNumberForm-labelText-DtQfC`,
	"modalCaptionLink": `VerifyPhoneNumberForm-modalCaptionLink-FuW1H`,
	"modalCaptionLinkLarge": `VerifyPhoneNumberForm-modalCaptionLinkLarge-K6HKa`,
	"formContainer": `VerifyPhoneNumberForm-formContainer-yaSMA`,
	"btnContainer": `VerifyPhoneNumberForm-btnContainer-mTUHq`
};
module.exports = ___CSS_LOADER_EXPORT___;
